import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { LinkService } from '../../../_services/langhfre.service';
import { NavigationService } from 'src/app/_services/navigation.service';

@Component({
  selector: 'app-on-premise-grammar-checker',
  templateUrl: './on-premise-grammar-checker.component.html',
  styleUrls: ['./on-premise-grammar-checker.component.scss']
})
export class OnPremiseGrammarCheckerComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    private LinkService: LinkService,
    public navigationService: NavigationService
  ) { 
  }

  ngOnInit() {
    this.titleService.setTitle("On-premise Grammar Checker for Enterprises | Trinka AI");
    this.metaTagService.updateTag({ name: 'description', content: "Trinka AI provides robust on-premise grammar checker solution for enterprises, providing unmatched data security, customizable features, seamless integration, and support." });
    this.metaTagService.updateTag({ property: 'og:title', content: "Academic Integrity Solutions for Universities" });
    this.metaTagService.updateTag({ property: 'og:description', content: "Robust on-premise grammar checker with unmatched data security, seamless integration, and support." });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/enterprise/on-premise-grammar-checker' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: "Academic Integrity Solutions for Universities" });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "Robust on-premise grammar checker with unmatched data security, seamless integration, and support." });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.metaTagService.updateTag({ name: 'language', content: 'en-us' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/enterprise/on-premise-grammar-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/enterprise/on-premise-grammar-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/enterprise/on-premise-grammar-checker' });
    
  }


}
